import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export const MultivalueInput = (props) => {
    const { title, elements, value, onChange } = props;

    return (
        <Autocomplete
            {...props}
            multiple
            id="fixed-tags-demo"
            value={value}
            onChange={(event, newValue) => {
                onChange([
                    ...newValue
                ]);
            }}
            options={elements}
            getOptionLabel={(option) => option.name}
            renderValue={(values, getItemProps) =>
                values.map((option, index) => {
                    const { key, ...itemProps } = getItemProps({ index });
                    return (
                        <Chip
                            key={option.id}
                            label={option.name}
                            {...itemProps}
                        />
                    );
                })
            }
            renderInput={(params) => (
                <TextField {...params} label={title} placeholder={title} />
            )}
        />
    );
}